import { render, staticRenderFns } from "./EducationalJoiningApplicationTable.vue?vue&type=template&id=1f8d5fa1&"
import script from "./EducationalJoiningApplicationTable.vue?vue&type=script&lang=js&"
export * from "./EducationalJoiningApplicationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports